/**
 * PostHog analytics wrapper.
 * Safe no-op when PostHog isn't loaded (dev without script, ad-blockers).
 */

const ph = () => window.posthog;

/** Identify a user after login/register. Links all future events to this user. */
export function identify(userId, traits = {}) {
  ph()?.identify(userId, traits);
}

/** Set person properties (e.g. tier, balance) without creating a new event. */
export function setPersonProperties(props) {
  ph()?.people?.set(props);
}

/** Capture a named event with optional properties. */
export function capture(event, props = {}) {
  ph()?.capture(event, props);
}

/** Reset identity on logout — unlinks session from user. */
export function reset() {
  ph()?.reset();
}
